import consumer from "./consumer.js"

consumer.subscriptions.create("StepsChannel", {
  connected() {},
  disconnected() {},
  received(data) {
    const versionsContainer = document.getElementById('versions-container');
    if (versionsContainer) {
      const newVersion = document.createElement('div');
      newVersion.innerHTML = data.html;

      const children = versionsContainer.children;
      if (children.length >= 20) {
        versionsContainer.removeChild(versionsContainer.lastElementChild);
      }

      if (versionsContainer.firstChild) {
        versionsContainer.insertBefore(newVersion, versionsContainer.firstChild);
      } else {
        versionsContainer.appendChild(newVersion);
      }
    }
  }
});
